import { Button } from '@/components/ui/button.tsx'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog.tsx'
import { Input } from '@/components/ui/input.tsx'
import { Separator } from '@/components/ui/separator.tsx'
import { useRef, useState } from 'react'
import type * as React from 'react'

type Props = {
  link: string
  children: React.ReactNode
}

export const ShareDialog = ({ link, children }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isCopied, setIsCopied] = useState(false)

  const copy = () => {
    if (!inputRef.current) return

    const textInputElement = inputRef.current
    textInputElement.select()
    textInputElement.setSelectionRange(0, textInputElement.value.length)

    navigator.clipboard.writeText(textInputElement.value).then(() => {
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 400)
    })
  }

  return (
    <Dialog>
      <DialogTrigger tabIndex={0} asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="rounded-lg p-0 gap-0 [&>button:last-child]:hidden">
        <DialogHeader className="p-4">
          <DialogTitle>Copy Project Link</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <Separator />
        <div className="flex items-center p-4">
          <div className="flex gap-2 w-full items-center">
            <Input ref={inputRef} id="link" value={link} readOnly className="h-8 bg-surface-backgroundElevated" />
            <Button type="button" size="icon" variant="icon" className="w-8 h-8" onClick={copy}>
              <img
                src="/images/copy-icon.svg"
                alt="copy link"
                className={`absolute transition-opacity duration-200 ${isCopied ? 'opacity-0 scale-75' : 'opacity-100 scale-100'}`}
              />
              <img
                src="/images/copied-icon.svg"
                alt="copied"
                className={`absolute transition-opacity duration-200 ${isCopied ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}
              />
            </Button>
          </div>
        </div>
        <DialogClose asChild>
          <Button type="button" size="icon" variant="ghost" className="absolute top-[18px] right-[16px]">
            <img src="/images/close-dialog-icon.svg" alt="close" />
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
